import { MutableRefObject } from 'react';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { shownCumulativeProbabilities } from 'views/simulations/simulations';
import { addChart } from 'views/report/utils/add-chart/add-chart.ts';
import { lineInterval } from 'views/report/utils/style-consts.ts';
import { addTitle } from 'views/report/utils/add-title/add-title.ts';
import { formatToMillions } from 'client/common/format-data/format-to-millions.ts';

export const addCumulativeProbabilityCostPage = async (
  doc: jsPDF,
  padding: number,
  forecastLogoHeight: number,
  chartRef: MutableRefObject<null>,
  simulationsResult: any,
  primaryCurrency: string,
) => {
  doc.addPage();

  addTitle(doc, 'Cumulative Probability (Cost)', {
    x: padding,
    y: forecastLogoHeight + padding + lineInterval,
  });

  const chart = await addChart(doc, chartRef);

  const { probabilities, costs } = simulationsResult?.cumulative_probability_cost || {};
  const tableData =
    costs
      ?.filter((_: number, index: number) => shownCumulativeProbabilities.includes(index))
      .map((cost: number) => formatToMillions(cost)) || [];

  const tableStartY = padding + forecastLogoHeight + chart.chartHeight + 2 * lineInterval;
  autoTable(doc, {
    head: [
      ['', ...shownCumulativeProbabilities].map((probability) => ({
        content: probabilities?.[probability] ?? '',
        styles: { fontStyle: 'bold' },
      })),
      ['', ...shownCumulativeProbabilities].map((_, idx) => ({
        content: idx ? `M${primaryCurrency}` : '',
        styles: { fontStyle: 'italic' },
      })),
    ],
    body: [[{ content: 'Estimated cost', styles: { fontStyle: 'bold' } }, ...tableData]],
    startY: tableStartY,
    theme: 'plain',
    columnStyles: {
      0: { cellWidth: 30 },
      1: { cellWidth: 'auto' },
    },
    styles: {
      fontSize: 10,
      cellPadding: { top: 2, right: 2, bottom: 2, left: 0 },
      halign: 'left',
    },

    didDrawCell: (data) => {
      const { cell, doc } = data;
      const { x, y, width, height } = cell;
      // Draw bottom border for each cell
      doc.setDrawColor('#90908d');
      doc.setLineWidth(0.2);
      doc.line(x, y + height, x + width, y + height);
    },
    margin: { top: 30 },
  });
};
